import { Box } from "@mui/material";
const Tiquets = () => {
  return <Box>Tiquets</Box>;
};
export default Tiquets;
